/* eslint-disable @nx/enforce-module-boundaries */
import { FilterType } from '@heitown/common-interfaces';
import { SelectItem } from './select-item';

export interface FilterConfig {
  // per form ricerca
  field: string;
  elementLabel: string;
  filterType: FilterType;
  elementValues?: SelectItem[];
  showIntoMoreFilters?: boolean;
  entityName?: string;
  /** Set to `true` to allow sorting on this column. Default: `false` */
  sortable?: boolean;
  /** If sorting by default, set it here. Set to `asc` or `desc`. */
  sort?: string | null;
  readOnly?: boolean;
}
